import { TypographyH4, TypographyP } from '@talentmesh/ui/components/typography';
import { cn } from '@talentmesh/ui/lib/utils';
import { ReactNode } from 'react';

interface InstructionItemProps {
    icon: ReactNode;
    header: string;
    instruction: string;
}

function InstructionItem({ icon, header, instruction }: InstructionItemProps) {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-row items-center gap-4">
                <div
                    className={cn(
                        'border-foreground flex size-8 shrink-0 items-center justify-center rounded-full border',
                    )}
                >
                    {icon}
                </div>
                <TypographyH4 className="text-foreground text-base">{header}</TypographyH4>
            </div>
            <TypographyP className="text-foreground">{instruction}</TypographyP>
        </div>
    );
}

export default InstructionItem;
